import { send } from 'server';

export const getPlayerTags = ({ tagName }) => send({
    ID: 35547,
    responses: [35548, 35549],
    description: 'Get Player Tag Request',
    tagName
});
